import { useEffect } from 'react'
import { useAuth } from '@praxis/component-auth'
import { useQuery } from '@apollo/client/react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import SplashPage from 'pages/SplashPage'
import { getSplashPageBanners, shouldShowSplashPage } from '../App/bannerUtils'
import { GET_ACTIVE_BANNERS } from 'graphql/queries/banner/bannerQueries'

type SplashRouteGateProps = {
  Layout: React.FC<unknown & { children?: JSX.Element }>
}

const SplashRouteGate = ({ Layout }: SplashRouteGateProps) => {
  const location = useLocation()
  const { isAuthenticated } = useAuth()
  const isLoggedIn = isAuthenticated()
  const { data: activeBanners, startPolling } = useQuery(GET_ACTIVE_BANNERS, {
    skip: !isLoggedIn,
  })
  const splashPageBanners = getSplashPageBanners(
    activeBanners?.getActiveBanners,
  )
  const shouldSkipSplashPage = localStorage.getItem('skipSplashPage') === 'true'
  // Pass the future permission result here when banner-admin access is supported.
  const showSplashPage = shouldShowSplashPage({
    hasActiveSplashPageBanner: splashPageBanners.length > 0,
    shouldSkipSplashPage,
  })

  useEffect(() => {
    if (isLoggedIn) {
      startPolling(10000)
    }
  }, [isLoggedIn, startPolling])

  if (showSplashPage) {
    return location.pathname === '/' ? (
      <SplashPage banners={splashPageBanners} />
    ) : (
      <Navigate to="/" replace />
    )
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}

export default SplashRouteGate
